import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';
import ResultLink from 'components/ResultLink';
import OppositionLink from 'components/OppositionLink';
import { Table, Th, Td } from 'components/Table';
import { howoutClass } from 'components/util';

export default class Batting87TrophyPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { entries } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="batting-87-trophy-page">
                    <Panel border>
                        <PanelTop title="87 Trophy" buttons />
                        <Batting87TrophyTable entries={entries} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const Batting87TrophyTable = ({ entries }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8" />
                <Th min="3" left>
                    Name
                </Th>
                <Th min="3" left>
                    How Out
                </Th>
                <Th min="3">Runs</Th>
                <Th min="3" priority="2">
                    Date
                </Th>
                <Th min="3" priority="3">
                    Team
                </Th>
                <Th priority="4" center />
                <Th priority="2" left>
                    Opposition
                </Th>
                <Th priority="4" left>
                    Location
                </Th>
                <Th priority="2" min="3" left>
                    Result
                </Th>
            </tr>
        </thead>
        <tbody>{entries.map((entry, index) => <Batting87TrophyRow key={`${entry.mid}/${entry.pid}`} index={index} entry={entry} />)}</tbody>
    </Table>
);

const Batting87TrophyRow = ({ entry, index }) => (
    <tr>
        <Td min="8">{index + 1}</Td>
        <Td min="3" left>
            <PlayerLink pid={entry.pid} fname={entry.fname} lname={entry.lname} runs={entry.runs} />
        </Td>
        <Td min="3" left className={howoutClass(entry.howout)}>
            {entry.howout}
        </Td>
        <Td min="3">{entry.runs}</Td>
        <Td min="3" short="4" value={entry.shortest_date} priority="2">
            {entry.short_date}
        </Td>
        <Td min="3" priority="3">
            {entry.team_sname}
        </Td>
        <Td priority="4" center>
            v
        </Td>
        <Td ellipsis="3" priority="2" left>
            <OppositionLink opposition={entry.opposition} url={entry.url} />
        </Td>
        <Td priority="4" left>
            {entry.location}
        </Td>
        <Td priority="2" min="3" left>
            <ResultLink fixture={entry} />
        </Td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/views/batting-87-trophy/Batting87TrophyPage.jsx